import { Switch as SwitchPrimitive } from "radix-ui";
import type React from "react";
import { cn } from "../../tailwind/cn";

export interface SwitchProps extends React.ComponentProps<typeof SwitchPrimitive.Root> {}

function Switch({ className, ...props }: Readonly<SwitchProps>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-[22px] w-[36px] shrink-0 items-center rounded-full border border-transparent transition-all duration-500 outline-none data-disabled:cursor-not-allowed data-disabled:opacity-50 data-[state=checked]:bg-brand data-[state=unchecked]:bg-medium-gray",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="pointer-events-none block size-[14px] rounded-full bg-background shadow-back ring-0 transition-transform duration-300 data-[state=checked]:translate-x-[16px] data-[state=unchecked]:translate-x-[3px]"
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
